import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Public
export const fetchDailyInsight = async () => (await api.get("/daily-insight")).data;
export const fetchTakenSlots = async (date) => (await api.get("/bookings/taken-slots", { params: { date } })).data.taken || [];
export const createBooking = async (payload) => (await api.post("/bookings", payload)).data;
export const fetchPublicBooking = async (id) => (await api.get(`/bookings/public/${id}`)).data;

// Admin
export const verifyAdmin = async (password) => (await api.post("/admin/verify", { password })).data;
export const listBookings = async (password) => (await api.get("/bookings", { headers: { "X-Admin-Password": password } })).data;
export const updateBookingStatus = async (id, status, password, { notify_client = false, reason = null } = {}) =>
  (await api.patch(`/bookings/${id}`, { status, notify_client, reason }, { headers: { "X-Admin-Password": password } })).data;
export const updateBookingNotes = async (id, payload, password) =>
  (await api.patch(`/bookings/${id}/notes`, payload, { headers: { "X-Admin-Password": password } })).data;

// Auth (token applied by AuthContext)
export const signupApi = async (payload) => (await api.post("/auth/signup", payload)).data;
export const loginApi = async (payload) => (await api.post("/auth/login", payload)).data;
export const meApi = async () => (await api.get("/auth/me")).data;

// Profile
export const myBookings = async () => (await api.get("/me/bookings")).data;
export const myGoals = async () => (await api.get("/me/goals")).data;
export const createGoalApi = async (payload) => (await api.post("/me/goals", payload)).data;
export const updateGoalApi = async (id, payload) => (await api.patch(`/me/goals/${id}`, payload)).data;
export const deleteGoalApi = async (id) => (await api.delete(`/me/goals/${id}`)).data;
